<div class="modal-header">
  <h4 class="modal-title smodal-title fl">회사검색</h4>
  <button type="button" class="close" (click)="activeModal.dismiss()">&times;</button>
</div>

<div class="modal-body">
  <div class="search-txt">
    <input type="text" class="search-input" [(ngModel)]="search.searchText" (keypress)="searchList($event)" size="20" maxLength="50" placeholder="기업명 또는 주담당자" [autofocus]="true" />
    <button type="button" class="btn search-btn" (click)="getCompanySearchList()">검색</button>
  </div>

  <p class="search-cnt">검색결과: {{companyList.length}}건</p>

  <div class="search-list">
    <table class="list-table">
    <colgroup>
      <col style="width:20%" />
      <col style="width:50%" />
      <col style="width:30%" />
      <!--
      <col style="width:30%" />
      -->
     </colgroup>

    <thead>
    <tr>
       <th scope="col">선택</th>
       <th scope="col">회사명</th>
       <th scope="col">대표자</th>
       <!--
       <th scope="col">사업자번호</th>
       -->
    </tr>
    </thead>

    <tbody>
    <ng-container *ngIf="companyList.length > 0">
    <tr class="cp" *ngFor="let item of companyList; let i = index;" (click)="companyIndex = i" (click)="submitSelectedCompany()">
      <td class="center"><input type="radio" name="select" [(ngModel)]="companyIndex" [value]="i"></td>
      <td class="center">{{item.companyName}}</td>
      <td class="center">{{item.ceoName}}</td>
      <!--
      <td class="center">{{item.comNumber}}</td>
      -->
    </tr>
    </ng-container>
    <ng-container *ngIf="companyList.length < 1">
    <tr>
      <td colspan="3" class="center">검색 결과가 없습니다.</td>
    </tr>
    </ng-container>
    </tbody>

    </table>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-default ml10" (click)="activeModal.dismiss()">창닫기</button>
</div>
